
import { COMMUNICATIONS, CommunicationService, Dots, CommunicationCenterOptions, StarFilled, addParamsToUrl, CommunicationCenterOptionsActions} from '@/imports-files/pages/clients/communication/index';


export class CommunicationAction
{
    constructor(setCommunicationList, setFlagForRerender,  setCommunicationBulkActionModal, setConfirmationModal, setApiError, setFiltersValue, router, setCommunicationFilter, setShowLoader)
    {
        this.communicationService               =  new CommunicationService();
        this.setCommunicationList               =  setCommunicationList;
        this.setFlagForRerender                 =  setFlagForRerender
        this.setCommunicationBulkActionModal    =  setCommunicationBulkActionModal;
        this.setConfirmationModal               =  setConfirmationModal;
        this.setApiError                        =  setApiError;
        this.CommunicationCenterOptionsActions  =  new CommunicationCenterOptionsActions(router);
        this.setFiltersValue                    =  setFiltersValue
        this.router                             =  router
        this.setCommunicationFilter             =  setCommunicationFilter
        this.setShowLoader                      =  setShowLoader
    }

    getColumnsName(t,router)
    { 
        return  ([{
            name: '',
            selector: row => { return (<div> 
                <StarFilled className={ row.important ? 'ImportantEmail' : 'NotImportantEmail'} onClick={(event)=>{this.CommunicationCenterOptionsActions.toggle(event, row, 'index_page')}}/>
            </div>)},
            sortable: false
            // sortField: 'sender'
        },
                    {
                        name: this.router.query.email_type=='sent' ? t('datatable:to') : t('datatable:from'),
                        selector: row => { return (<div  className = { this.router.query.email_type=='sent' ? 'Read DPBlock' : (row.read ? "Read DPBlock": 'Unread DPBlock') } onClick={ async (event)=>{  await this.CommunicationCenterOptionsActions.markAsRead( {options: COMMUNICATIONS(t).action_options,  performAction: this.performAction,id :row.id, setCommunicationList : this.setCommunicationList, setFlagForRerender: this.setFlagForRerender, setCommunicationBulkActionModal: this.setCommunicationBulkActionModal,setConfirmationModal: this.setConfirmationModal, setApiError: this.setApiError, closeAllJobsOptions: this.closeAllJobsOptions(), row :row, redirect: true})}}>
                            {row.sender} 
                        </div>)},
                        sortable: false
                        // sortField: 'sender'
                    },
                    {
                        name: t('datatable:description'),
                        selector: row => { return (<div className={ this.router.query.email_type=='sent' ? 'Read DPBlock' : (row.read ? "Read DPBlock" : 'Unread DPBlock')} onClick={async () => {  await this.CommunicationCenterOptionsActions.markAsRead( {options: COMMUNICATIONS(t).action_options,  performAction: this.performAction,id :row.id, setCommunicationList : this.setCommunicationList, setFlagForRerender: this.setFlagForRerender, setCommunicationBulkActionModal: this.setCommunicationBulkActionModal,setConfirmationModal: this.setConfirmationModal, setApiError: this.setApiError, closeAllJobsOptions: this.closeAllJobsOptions(), row :row, redirect: true})}}>{row.description}</div>)},
                        sortable: false
                    },
                    {
                        name: t('datatable:when'),
                        selector: row => { return (<div className={ this.router.query.email_type=='sent' ? 'Read DPBlock' : (row.read ? "Read" : 'Unread DPBlock')} onClick={ async () => {   await this.CommunicationCenterOptionsActions.markAsRead( {options: COMMUNICATIONS(t).action_options,  performAction: this.performAction,id :row.id, setCommunicationList : this.setCommunicationList, setFlagForRerender: this.setFlagForRerender, setCommunicationBulkActionModal: this.setCommunicationBulkActionModal,setConfirmationModal: this.setConfirmationModal, setApiError: this.setApiError, closeAllJobsOptions: this.closeAllJobsOptions(), row :row, redirect: true}) }}>{row.when}</div>)},
                        sortable: false
                        // sortField: 'created_at'
                    },
                    {
                         name: '',
                         selector: row => { return (
                                                                <div className="DotsOptions" onClick={(event) => this.openJobOptions(event)}> 
                                                                    <Dots className="Dots Close" />
                                                                    <CommunicationCenterOptions options                         =   {COMMUNICATIONS(t).action_options}
                                                                                                performAction                   =   {this.performAction}
                                                                                                id                              =   {row.id}
                                                                                                setCommunicationList            =   {this.setCommunicationList}
                                                                                                setFlagForRerender              =   {this.setFlagForRerender}
                                                                                                setCommunicationBulkActionModal =  {this.setCommunicationBulkActionModal}
                                                                                                setConfirmationModal            =  {this.setConfirmationModal}
                                                                                                setApiError                     =  {this.setApiError}
                                                                                                closeAllJobsOptions             =  {this.closeAllJobsOptions()}
                                                                                                row                             =  {row}/>
                                                                </div>
                                                    )}
                                
                    }
                ])
    }    
    
    async getCommunicationData(params)
    {
        this.setShowLoader(true);
        var result = '';
        let urlParams =   new URLSearchParams(window.location.search);
        let type = urlParams.get('email_type');
        params.email_type = type;
        result = await this.communicationService.getCommunicationData(params);
        this.setApiError(result.response);
         this.setShowLoader(false);
        return result;
    }


    openJobOptions(event)
        {
            event.stopPropagation();
            var dots_element = event.currentTarget.querySelector('.Dots');
            var element = event.currentTarget.querySelector('.CommunicationsOptions')

            if(dots_element.classList.contains('Close'))
            {
                this.closeAllJobsOptions();
                element.classList.remove('Close');
                element.classList.add('Open');

                dots_element.classList.remove('Close');
                dots_element.classList.add('Open');
            }
            else
            {
                this.closeAllJobsOptions();
                element.classList.remove('Open');
                element.classList.add('Close');

                dots_element.classList.remove('Open');
                dots_element.classList.add('Close');
            }
    }
    
    closeAllJobsOptions()
    {
        var element = document.querySelector('.CommunicationsOptions.Open');
        var dots_element = document.querySelector('.Dots.Open');
        if(element)
        {
            element.classList.remove('Open');
            element.classList.add('Close');
            dots_element.classList.remove('Open');
            dots_element.classList.add('Close');
        }
    }

       async handlePerRowsSorting(router, column, sortDirection, setCommunicationList, setFiltersValue, setApiError)
       {
        var previous_job_filter           =    router.query;
        previous_job_filter.col_name      =    column.sortField;
        previous_job_filter.order         =    sortDirection;
        addParamsToUrl(previous_job_filter, router);
        setFiltersValue(previous_job_filter);
        var result = await this.getCommunicationData(previous_job_filter);
        setCommunicationList(result.data);   
        this.setFlagForRerender(Math.random() * 10000);
        }


    async handlePerRowsChange(router, per_page, setCommunicationList, setFiltersValue, setApiError)
    {
        var previous_job_filter                  =    router.query;
        previous_job_filter.per_page             =    per_page;
        addParamsToUrl(previous_job_filter, router);
        setFiltersValue(previous_job_filter);
        var result  =  await this.getCommunicationData(previous_job_filter);
        setCommunicationList(result.data);   
        this.setFlagForRerender(Math.random() * 10000);
    }

    async handlePageChange(router, page, setCommunicationList, setFiltersValue, setApiError)
    {
        var previous_job_filter         =    router.query;
        previous_job_filter.page        =    page;
        addParamsToUrl(previous_job_filter, router);
        setFiltersValue(previous_job_filter);
        var result  =  await this.getCommunicationData(previous_job_filter);
        setApiError(result.request)
        setCommunicationList(result.data);   
        this.setFlagForRerender(Math.random() * 10000);
    }

    onSelectingRows(selected_rows, setCommunicationBulkActionModal, setSelectedComms)
    {
        if(selected_rows.selectedCount > 0)
        {
            setCommunicationBulkActionModal(true);
            setSelectedComms(selected_rows);
        }
        else
        {
            setCommunicationBulkActionModal(false);
            setSelectedComms(selected_rows);
        }
    }

    changeSearchFilterData( event)
    {
         setTimeout(async () => {
                            var param_list            =    this.router.query;
                            param_list.search_text    =    event.target.value ;
                            param_list.search_text    ==   '' ?  delete param_list.search_text : '';
                            addParamsToUrl(param_list, this.router);
                            var result                =  await this.getCommunicationData(param_list)
                            this.setApiError( result.request );
                            this.setCommunicationList(result.data);
                            this.setFiltersValue(param_list);  
                          }, 500)
    }

    handleCommunicationFilterClick(event)
    {
        this.setCommunicationFilter({state:true, message:'', confirm_btn_action:null});
        this.setFlagForRerender(Math.random() * 10000);

    }

    isFilterApplied()
    {
        var previous_job_filter  =  this.router.query
        return previous_job_filter?.job_title || previous_job_filter?.candidate_name || previous_job_filter?.important || previous_job_filter.non_interview;
    }


    deselectAllCandidates()
    {
        var all_checkbox = document.querySelector('[name = select-all-rows]')
        if(all_checkbox)
        {
            if(all_checkbox?.checked)
            {
                all_checkbox.click();
            }
            else
            {
                all_checkbox.click();
                all_checkbox.click();
            }
        }
    }
}